import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://landingpage.aquaware.no';
const SITE_NAME = 'AquaWARE';
const DEFAULT_IMAGE = `${SITE_URL}/images/banner_AQW.png`;

type SEOProps = {
  title: string;
  description: string;
  path?: string; // e.g. '/products' - defaults to '/'
  image?: string; // absolute or root-relative URL
  noindex?: boolean; // exclude this page from search engine indexing
};

const SEO = ({ title, description, path = '/', image = DEFAULT_IMAGE, noindex = false }: SEOProps) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = path === '/' ? title : `${title} | ${SITE_NAME}`;
  const absoluteImage = image.startsWith('http') ? image : `${SITE_URL}${image}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <link rel="canonical" href={url} />
      )}

      {/* Open Graph (used by LinkedIn, Slack, WhatsApp, Facebook, etc.) */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={absoluteImage} />
    </Helmet>
  );
};

export default SEO;
